<template lang="pug">
    footer
        nav#footer-menu(v-if="items && items.length")
            .container
                tree-menu(:items="items" :max-depth="1" :allow-multiple-active-items="true" :delay="100")
        #va-footer
            small.has-text-centered Erstellt mit CityPage, dem Webbaukasten der Vanameland
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import cloneDeep from 'lodash.clonedeep'
import { mapGetters } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default{
    name: 'Footer',
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'footer-menu')
            let items = get(menu, 'menuItems') || []
            items = cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        ...mapGetters({
            menus: 'menus',
            config: 'config',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    footer
        background-color: #4c4c4c
        color: #ffffff
        position: relative
        margin-top: 50px
        nav#footer-menu /deep/
            a
                color: #ffffff
            ul
                & > li
                    text-align: center
                    a
                        display: block
                        padding: 10px 20px
                +desktop
                    display: flex
                    & > li
                        flex-grow: 1
                        flex-basis: 100%
                        text-transform: uppercase
                        border-right: 1px solid #666666
                        &:last-child
                            border-right: none
                        a
                            height: 100px
                            display: flex
                            justify-content: center
                            align-items: center
                        &.visible
                            a
                                background-color: #666666
        div#va-footer
            font-size: .8rem
            padding: 4px
            text-align: center
            background-color: rgba(0, 0, 0, .2)
            +desktop
                background-color: initial
                font-size: .9rem
                position: absolute
                bottom: 100%
                color: #4c4c4c
                width: 100%
                text-align: center
</style>
